import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth"; // adjust the path if needed
import cartReducer from "./slices/cart";
import genreReducer from "./slices/genre";

const store = configureStore({
  reducer: {
    auth: authReducer, // add more slices here as your app grows
    cart: cartReducer,
    genre: genreReducer,
  },
  devTools: process.env.NODE_ENV !== "production", // enables Redux DevTools
});

export default store;
